"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LOCALE_REGEXP: function() {
        return LOCALE_REGEXP;
    },
    SUBDOMAIN_REGEXP: function() {
        return SUBDOMAIN_REGEXP;
    },
    TRACKING_DEFAULT_SERVICE: function() {
        return TRACKING_DEFAULT_SERVICE;
    },
    TRACKING_EXTRA_ATTRIBUTES: function() {
        return TRACKING_EXTRA_ATTRIBUTES;
    },
    ZERO_UUID: function() {
        return ZERO_UUID;
    }
});
var SUBDOMAIN_REGEXP = /^([^.]+)\./;
var LOCALE_REGEXP = /^\/([a-z]{2})\//;
var ZERO_UUID = "00000000-0000-0000-0000-000000000000";
var TRACKING_DEFAULT_SERVICE = "jobteaser";
var TRACKING_EXTRA_ATTRIBUTES = {
    COURSE_IDS: "course_ids"
};

//# sourceMappingURL=constants.js.map